import React, { useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Panel } from "../ui-kit";
import { NAV } from "../Layout";
import { useAuth } from "../../context/AuthContext";

export function MenuVisibility() {
  const { user, canAccess, reload } = useAuth();
  const [hidden, setHidden] = useState(user?.hidden_menu || []);
  const items = NAV.filter((n) => n.to !== "/settings" && canAccess(n.mod));
  const toggle = async (to) => {
    const next = hidden.includes(to) ? hidden.filter((h) => h !== to) : [...hidden, to];
    setHidden(next);
    try { await client.put("/auth/me/hidden-menu", { hidden: next }); await reload(); }
    catch (e) { setHidden(hidden); toast.error(apiErr(e)); }
  };
  return (
    <Panel title="Menu Visibility" className="lg:col-span-2" testid="menu-visibility">
      <div className="p-4">
        <p className="text-[11px] text-slate-500 mb-3">Jo menu use nahi karte unhe band kar dein. Ye sirf aapke login ke sidebar pe asar karega, aur page link se ab bhi khul sakta hai.</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {items.map((n) => {
            const on = !hidden.includes(n.to);
            return (
              <label key={n.to} data-testid={`menu-toggle-${n.to.slice(1)}`} className={`flex items-center gap-2.5 px-3 py-2 border cursor-pointer text-sm transition-colors duration-200 ${on ? "border-gold/40 text-white" : "border-[color:var(--border-subtle)] text-slate-500"}`}>
                <input type="checkbox" checked={on} onChange={() => toggle(n.to)} className="accent-[#d4af37]" />
                <n.icon size={15} strokeWidth={1.8} />{n.label}
              </label>
            );
          })}
        </div>
      </div>
    </Panel>
  );
}
